import { IdentityUserAri } from '@atlassian/ari/identity/user';

export const getUserAri = (userId?: string | null): IdentityUserAri | null => {
	if (!userId) {
		return null;
	}
	try {
		return IdentityUserAri.create({ userId });
	} catch (error) {
		return null;
	}
};
